import React from 'react'

import { NotificationSoundToggle } from '@/components/atoms/NotificationSoundToggle/NotificationSoundToggle.tsx'
import { cn } from '@/lib/utils.ts'

export interface NotificationSoundProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  state?: 'enabled' | 'muted'
}

export const NotificationSound = React.forwardRef<HTMLButtonElement, NotificationSoundProps>(
  ({ className, state = 'enabled', ...props }, ref) => (
    <NotificationSoundToggle state={state} ref={ref} className={cn(className)} {...props} />
  )
)
